import { HeroFull } from "@/components/HeroFull";
import { HERO_IMAGE_DEFAULT } from "@/config/images";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import WhatsAppFloating from "../../components/feature/WhatsAppFloating";
import CookieBanner from "../../components/feature/CookieBanner";
import SEO from "../../components/feature/SEO";
import WhatWeDoSection from "./components/WhatWeDoSection";
import PersianasServicesSection from "./components/PersianasServicesSection";
import ServicesSection from "./components/ServicesSection";
import SocialProofSection from "../../components/feature/SocialProofSection";
import WhyUsSection from "./components/WhyUsSection";
import AboutSection from "./components/AboutSection";
import ZonesSection from "./components/ZonesSection";
import HowWeWorkSection from "./components/HowWeWorkSection";
import QuoteFormSection from "./components/QuoteFormSection";
import FAQSection from "../../components/feature/FAQSection";

const homeFAQs = [
  {
    q: "¿Cuánto cuesta cambiar una cinta de persiana en Málaga?",
    a: "El cambio de cinta de persiana en Málaga cuesta desde 60€, incluyendo desplazamiento, mano de obra y la nueva cinta. El trabajo se realiza en menos de una hora. Te damos presupuesto exacto y gratuito tras visita.",
  },
  {
    q: "¿En cuánto tiempo venís a reparar mi persiana?",
    a: "Visitamos tu domicilio en menos de 24 horas desde tu llamada. Para urgencias en Málaga capital, intentamos llegar el mismo día si nos contactas antes de las 12h.",
  },
  {
    q: "¿Trabajáis en toda la Costa del Sol o solo en Málaga capital?",
    a: "Cubrimos toda la provincia: Málaga capital, Marbella, Fuengirola, Torremolinos, Benalmádena, Mijas y Estepona. Sin coste de desplazamiento en estas zonas.",
  },
  {
    q: "¿Qué marcas de motores de persiana reparáis?",
    a: "Trabajamos con todas las marcas del mercado: Somfy, Cherubini, Becker, Nice y motores genéricos. Tenemos repuestos de las marcas más comunes en stock.",
  },
  {
    q: "¿Cuánto cuesta motorizar una persiana manual?",
    a: "La motorización de una persiana manual cuesta desde 150€ con motor nuevo, instalación y garantía de 2 años. El precio exacto depende del tamaño y peso de la persiana.",
  },
  {
    q: "¿Dais garantía en las reparaciones?",
    a: "Sí, todas nuestras reparaciones e instalaciones llevan garantía de 2 años en piezas y mano de obra. Si algo falla, volvemos sin coste adicional.",
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        ogImage="https://persianas-toldos-malaga.es/og/og-default.jpg"
        ogType="website"
        noHreflang={false}
        faqs={homeFAQs}
      />
      <Header />
      <main>
        <HeroFull
          imageSrc={HERO_IMAGE_DEFAULT}
          imageAlt="Técnico de Persianas Toldos Málaga reparando una persiana eléctrica en una vivienda de la Costa del Sol"
          badge="⚡ 24h · Respuesta en 20 min · Málaga"
          title="Persianas en Málaga: reparación, motor e instalación en 24h"
          subtitle="También ofrecemos toldos y mosquiteras en toda la Costa del Sol. Empresa local con técnico propio, sin intermediarios. Presupuesto gratis en 24h."
          primaryCta={{ href: "tel:+34951120770", label: "Llamar: 951 12 07 70" }}
          secondaryCta={{ href: "#presupuesto", label: "Pedir presupuesto" }}
          trustSignals={["+10 años de experiencia", "Seguro RC", "Garantía 2 años", "Empresa local desde 2015"]}
        />
        <WhatWeDoSection />
        <SocialProofSection />
        <PersianasServicesSection />
        <ServicesSection />
        <WhyUsSection />
        <AboutSection />
        {/* P0 FIX: Sección de testimonios ficticios eliminada.
            Se activará con reviews verificadas de Google post-launch. */}
        <section className="my-12 max-w-3xl mx-auto px-4 bg-surface-alt rounded-2xl p-8 text-center">
          <h2 className="text-xl font-bold mb-3">Construyendo nuestra reputación en Málaga</h2>
          <p className="text-gray-700 leading-relaxed">
            Trabajamos en Málaga desde 2015 con técnico propio, sin intermediarios.
            Si has sido cliente, déjanos una reseña en Google — nos ayuda a seguir
            creciendo y mejorar el servicio.
          </p>
          <a
            href="https://www.google.com/maps/search/?api=1&query=Persianas+Toldos+Málaga"
            className="inline-block mt-4 px-6 py-3 bg-primary text-white rounded-lg font-semibold hover:bg-primary-dark"
            target="_blank"
            rel="noopener noreferrer"
          >
            Dejar reseña en Google ⭐
          </a>
        </section>
        <ZonesSection />
        <HowWeWorkSection />
        <FAQSection
          title="Preguntas frecuentes sobre persianas, toldos y mosquiteras en Málaga"
          items={homeFAQs}
        />
        <QuoteFormSection />
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}